export enum Status {
	progress = 'Progress',
	success = 'Success',
	failed = 'Failed',
	pending = 'Pending',
	cancelled = 'Cancelled',
	notUsed = 'notUsed'
}

